/**
 * Reading progress bar (.bq-article__progress) for journal articles.
 * On desktop from 990px the scroller is .page-wrapper, not the root.
 */
(function () {
  function init(scope) {
    const body = scope.querySelector('[data-bq-article-body]');
    const bar = scope.querySelector('.bq-article__progress');
    if (!body || !bar || bar.dataset.bqProgressInit) return;
    bar.dataset.bqProgressInit = '1';

    const squeeze = window.matchMedia('(min-width: 990px)');
    const scroller = function () {
      return (
        (squeeze.matches && document.querySelector('.page-wrapper')) ||
        document.scrollingElement ||
        document.documentElement
      );
    };
    const scrollTarget = function () {
      return (squeeze.matches && document.querySelector('.page-wrapper')) || document;
    };
    let ticking = false;
    let bound = null;
    // The scroller outlives the section: unbind once the bar is gone rather than
    // keep measuring a detached node.
    const release = function () {
      if (bound) bound.removeEventListener('scroll', onScroll);
      bound = null;
      squeeze.removeEventListener('change', bind);
    };
    const update = function () {
      ticking = false;
      if (!bar.isConnected) {
        release();
        return;
      }
      const sc = scroller();
      const rect = body.getBoundingClientRect();
      let scTop = 0;
      if (sc !== document.scrollingElement && sc !== document.documentElement) {
        scTop = sc.getBoundingClientRect().top;
      }
      const start = sc.scrollTop + rect.top - scTop - sc.clientHeight * 0.6;
      const span = Math.max(1, rect.height - sc.clientHeight * 0.2);
      const p = Math.min(1, Math.max(0, (sc.scrollTop - start) / span));
      bar.style.setProperty('--bq-art-progress', p.toFixed(4));
    };
    const onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    function bind() {
      if (bound) bound.removeEventListener('scroll', onScroll);
      bound = scrollTarget();
      bound.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
    bind();
    squeeze.addEventListener('change', bind);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
